export default Object.freeze({
  ILS: 1,
  Berard: 2,
  Tomatis: 3,
});
